import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeatureSection from './components/FeatureSection';
import ArticlesSection from './components/ArticlesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import BottomContent from './components/BottomContent';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <CategoryGrid />
      <AboutSection />
      <FeatureSection />
      <ArticlesSection />
      <TestimonialSection />
      <CTASection />
      <BottomContent />
      <Footer />
    </main>
  );
}